import Vue from 'vue';

/**
 * Numbers common filters
 */

Vue.filter('integer', function(value) {
  value = parseInt(value);
  return isNaN(value) ? 0: value;
});

Vue.filter('float', function(value) {
  value = parseFloat(value);
  return isNaN(value) ? 0.0: value;
});

Vue.filter('decimal1', function(value) {
  value = parseFloat(value);
  if (isNaN(value)) {
    value = 0.0;
  }
  return value.toFixed(1);
});

Vue.filter('decimal2', function(value) {
  value = parseFloat(value);
  if (isNaN(value)) {
    value = 0.0;
  }
  return value.toFixed(2);
});

Vue.filter('decimal3', function(value) {
  value = parseFloat(value);
  if (isNaN(value)) {
    value = 0.0;
  }
  return value.toFixed(3);
});

Vue.filter('decimalToTime', function(value) {
  value = parseFloat(value);
  if (isNaN(value)) {
    value = 0.0;
  }

  value = Math.floor(value * 60);
  const minutes = value % 60;
  const hours = (value - minutes) / 60;
  return String(hours).padStart(2, '0') + ':' + (String(minutes).padStart(2, '0'));
});

